// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__33W8p","approved":"Status_approved__wShHP","rejected":"Status_rejected__3_3BM","expired":"Status_expired__2l3xs","label":"Status_label__kzyMS"};